import "./App.css";
import Sidebar from "./comp/Sidebar";
import Home from "./pages/Home";
import { TbMoonStars } from "react-icons/tb";
import { FiSun } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import { FiMenu } from "react-icons/fi";
import { useState } from "react";

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [menuBar, setMenuBar] = useState(true);

  return (
    <>
      <div className={darkMode ? "darkmode app" : "app"}>

        {
          menuBar ? <FiMenu onClick={() => setMenuBar(false)} className="menuIcon"/> :<RxCross2 onClick={() => setMenuBar(true)} className="menuIcon"/>
        }

        {!darkMode ? (
          <TbMoonStars onClick={() => setDarkMode(true)} className="mainIcon" />
        ) : (
          <FiSun onClick={() => setDarkMode(false)} className="mainIcon" />
        )}
        
        <Sidebar menuBar={menuBar} setMenuBar={setMenuBar} />
        <Home />
      </div>
    </>
  );
}

export default App;
